import { render, staticRenderFns } from "./apply-form.vue?vue&type=template&id=0b67a532&scoped=true&"
import script from "./apply-form.vue?vue&type=script&lang=js&"
export * from "./apply-form.vue?vue&type=script&lang=js&"
import style0 from "./apply-form.vue?vue&type=style&index=0&id=0b67a532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67a532",
  null
  
)

export default component.exports